<div class="view-module-version__container__header-container">
  <dcc-page-title class="view-module-version__container__header-container__header" title="Version Details"></dcc-page-title>
  <div class="view-module-version__container__header-container__close"
       (click)="close()"><i class="lx-icon lx-close-x"></i></div>
</div>

<div class="view-module-version__container__body">
  <content-with-label label="Version File">
    <div class="view-module-version__container__body__details__body lx-body">{{moduleVersion?.fileName}}</div>
  </content-with-label>

  <content-with-label label="Version">
    <div class="view-module-version__container__body__details__body lx-body">{{moduleVersion?.version}}</div>
  </content-with-label>

  <content-with-label label="Platform">
    <div class="view-module-version__container__body__details__body lx-body">{{moduleVersion?.platform}}</div>
  </content-with-label>

  <div *ngIf="configJsonAvailable">
    <content-with-label label="Configuration Schema Json">
      <div class="view-module-version__container__body__details__body lx-body">{{moduleVersion?.id}}</div>
    </content-with-label>
  </div>
</div>

<div class="view-module-version__button-container">
  <button class="lx-btn lx-btn-secondary"
          (click)="close()"><span>Close</span></button>
</div>
